"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
var _interopRequireWildcard = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVesselControlTypeById = getVesselControlTypeById;
exports.getVesselNameById = getVesselNameById;
exports.queryShip = queryShip;
exports.queryShipList = queryShipList;
exports.queryShipListAss = queryShipListAss;
exports.queryShipListDemo = queryShipListDemo;
exports.ship = void 0;
var _DaoServiceClientES6Adapter = _interopRequireWildcard(require("@/utils/daoService/DaoServiceClientES6Adapter"));
var _request = _interopRequireDefault(require("@/utils/request"));
/* 船舶相关接口 */

var ship = exports.ship = _DaoServiceClientES6Adapter.default.QCdmVesselGeneral.using(_DaoServiceClientES6Adapter.dsc);

// 根据ID获取hullNo、Imo
ship.queryHullNoImo = function (id) {
  return ship.selectOne(ship.vesselCnName, ship.vesselEnName, ship.hullNo, ship.imo).byId(id);
};
// 根据ID获取controlType,manageStyle
ship.queryControlType = function (id) {
  return ship.selectOne(ship.controlType, ship.manageStyle, ship.retiredFlag).byId(id);
};
// 根据ID获取ownerShip
ship.queryOwnerShip = function (id) {
  return ship.selectOne(ship.ownerShip).byId(id);
};
// 根据ID获取manageStyle
ship.queryManageStyle = function (id) {
  return ship.selectOne(ship.manageStyle).byId(id);
};
// 根据IDs获取manageStyle
ship.queryManageStyles = function (ids) {
  return ship.select(ship.manageStyle).where(ship.id.in$(ids)).execute();
};
ship.queryAllShip = function () {
  return (0, _request.default)({
    url: '/sitceb-system-service/cdmVesselGeneral/getAllShip',
    method: 'get'
  });
};
ship.queryVesselTeamEmail = function (params) {
  return (0, _request.default)({
    url: '/sitceb-system-service/api/mail/getVesselTeamEmail',
    method: 'get',
    params: params
  });
};
function queryShipList(query) {
  return _DaoServiceClientES6Adapter.dsc.withModel(ship).select(ship.fieldContainer()).paging(query.page, query.limit).where(ship.vesselCnNm.like(_DaoServiceClientES6Adapter.___).and(ship.id.eq(_DaoServiceClientES6Adapter.___)).and(ship.vesselEnNm.like(_DaoServiceClientES6Adapter.___))).tag('selectApply').execute(query);
}
/* 负责船舶管理-船舶列表-添加船舶-联想控件 */
function queryShipListAss(query) {
  if (query.keyword !== undefined) {
    query.vesselCode = '%' + query.keyword + '%';
    query.vesselCnName = '%' + query.keyword + '%';
    query.vesselEnName = '%' + query.keyword + '%';
    query.vesselType = '%' + query.keyword + '%';
  }
  var finalQuery;
  if (query.filterJson !== undefined) {
    var jsonData = JSON.parse(query.filterJson);
    for (var k in jsonData) {
      if (jsonData[k] === '' || jsonData[k] === null) {
        jsonData[k] = undefined;
      }
    }
    finalQuery = Object.assign(query, jsonData);
  } else {
    finalQuery = query;
  }
  return ship.select(ship.fieldContainer()).where(ship.ownerShip.in(_DaoServiceClientES6Adapter.___).and(ship.retiredFlag.in(_DaoServiceClientES6Adapter.___)).and(ship.managerId.in(_DaoServiceClientES6Adapter.___)).and(ship.shipOwnerId.in(_DaoServiceClientES6Adapter.___)).and(ship.companyId.in(_DaoServiceClientES6Adapter.___)).and(ship.superiorCompanyId.in(_DaoServiceClientES6Adapter.___)).and(ship.controlType.ne$(finalQuery.noEqControlType)).and(ship.vesselCnName.like(_DaoServiceClientES6Adapter.___).or(ship.vesselCode.like(_DaoServiceClientES6Adapter.___)).or(ship.vesselEnName.like(_DaoServiceClientES6Adapter.___)).or(ship.vesselType.like(_DaoServiceClientES6Adapter.___)))).paging(query.page, query.limit).sorting(ship.vesselCode).tag('selectShipAss').execute(finalQuery);
}
function queryShip(query) {
  return _DaoServiceClientES6Adapter.dsc.withModel(ship).selectOne(ship.fieldContainer()).where(ship.vesselCd.eq(_DaoServiceClientES6Adapter.___)).tag('selectShip').execute(query);
}
function queryShipListDemo(query) {
  return (0, _request.default)({
    url: '/vue-element-admin/ship/list',
    method: 'get',
    query: query
  });
}
function getVesselNameById(id) {
  return ship.select(ship.id, ship.vesselCnName, ship.vesselEnName, ship.vesselCode).where(ship.id.eq$(id)).tag('getVesselNameById').execute();
}
function getVesselControlTypeById(id) {
  return ship.selectOne(ship.controlType).where(ship.id.eq$(id)).tag('getVesselControlTypeById').execute();
}